import { render, staticRenderFns } from "./free-coin-edit.vue?vue&type=template&id=5490c1ea&"
import script from "./free-coin-edit.vue?vue&type=script&lang=js&"
export * from "./free-coin-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports